<div class="container fixed-bottom expander border-top">
  <div class="d-flex justify-content-end">
    <rx-button
      buttonClass="link mr-1 font-size-small"
      (click)="toggleIsBodyExpanded()"
      [icon]="isBodyExpanded ? 'rx-chevron-down' : 'rx-chevron-up'"
      iconPosition="right"
    >
      {{ isBodyExpanded ? collapseButtonText : expandButtonText }}
    </rx-button>
  </div>

  <div class="expander-body" [ngClass]="{ 'expanded border-bottom': isBodyExpanded }">
    <ng-content *ngIf="isBodyExpanded" select="[body]"></ng-content>
  </div>

  <div class="expander-bottom"><ng-content select="[bottom]"></ng-content></div>
</div>
